module.exports = __webpack_public_path__ + "img/newLogo3.eb561b39.png";